import { takeLatest } from 'redux-saga/effects'
import { LOAD_WHITELABELS_LIST } from 'app/redux-base/actions/whitelabelsList'
import loadWhitelabels from './loadWhitelabels'

export default function* watchLoadWhitelabels() {
  yield takeLatest(LOAD_WHITELABELS_LIST.REQUEST, loadWhitelabels)
}
